
export const handleNext = ({ list, current, isNext = true }) => {
    let nextIndex;
    let nextItem;
    let nextCount = 1;
    if (!isNext) nextCount = -1;
    if (list && list.length) {
        const itemIndex = list.findIndex(item => +item.id === +current.id);
        if (itemIndex > -1) {
            nextIndex = itemIndex + nextCount;
            if (nextIndex >= list.length || nextIndex < 0) nextIndex = 0;
            nextItem = list[nextIndex];
            if (nextItem && nextItem.id) {
                return { nextObj: nextItem, nextId: nextItem.id }
            }
        }
    }
    return false;
}